import { useSelector } from 'react-redux';
import { selectWhitelabelFeatures } from 'selectors/whitelabelSelectors';

/**
 * useWhitelabelFeatures hook. Return whitelabel feature flags from Redux state.
 * @returns {object} Feature flags object.
 */
const useWhitelabelFeatures = () => {
  const features = useSelector(selectWhitelabelFeatures);
  return features;
};

export default useWhitelabelFeatures;
